import axios from 'axios'

function handleStreamingPayload(payload, callbacks) {
    if (!payload || typeof payload !== 'object') return;

    if (payload.streaming === false) {
        callbacks.onComplete?.(payload);
        return;
    }

    if (payload.streaming === true && payload.type === undefined) {
        callbacks.onChunk?.(payload);
        return;
    }

    callbacks.onComplete?.(payload);
}

async function readStreamingJsonLines(response, callbacks) {
    const reader = response.body?.getReader?.();
    if (!reader) {
        const text = await response.text();
        const trimmed = text.trim();
        if (trimmed) {
            handleStreamingPayload(JSON.parse(trimmed), callbacks);
        }
        return;
    }

    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        let newlineIndex;
        while ((newlineIndex = buffer.indexOf('\n')) >= 0) {
            const line = buffer.slice(0, newlineIndex).trim();
            buffer = buffer.slice(newlineIndex + 1);
            if (line) {
                handleStreamingPayload(JSON.parse(line), callbacks);
            }
        }
    }

    const trailing = buffer.trim();
    if (trailing) {
        handleStreamingPayload(JSON.parse(trailing), callbacks);
    }
}

export default {
    getResources(url) {
        return axios.get(url);
    },
    getResourcesWithConfig(url, config) {
        return axios.get(url, config);
    },
    updateResources(url, payload) {
        return axios.put(url, payload);
    },
    postResources(url, payload) {
        return axios.post(url, payload);
    },
    postResourcesWithParams(url, payload, params) {
        return axios.post(url, payload, params);
    },
    postResourcesStreaming(url, payload, callbacks = {}) {
        const { signal } = callbacks;

        return axios.request({
            url,
            method: 'post',
            data: payload,
            headers: { 'Content-Type': 'application/json' },
            signal,
            adapter: async (config) => {
                const fullUrl = axios.getUri(config);
                const requestBody = typeof config.data === 'string'
                    ? config.data
                    : JSON.stringify(config.data);
                const response = await fetch(fullUrl, {
                    method: 'POST',
                    headers: config.headers,
                    body: requestBody,
                    signal: config.signal,
                });

                if (!response.ok) {
                    let errorBody = '';
                    try {
                        errorBody = await response.text();
                    } catch (e) {
                        /* ignore */
                    }
                    const error = new Error(`Request failed with status ${response.status}`);
                    error.response = {
                        status: response.status,
                        data: errorBody,
                    };
                    throw error;
                }

                await readStreamingJsonLines(response, callbacks);

                return {
                    data: null,
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                    config,
                };
            },
        });
    },
    deleteResources(url) {
        return axios.delete(url);
    }

}
